/** YaoXue activity subpackage copy — English */
export default {
  activity: {
    yx: {
      nav: {
        home: 'YaoXue Ice & Snow World',
        rules: 'YaoXue Activity Terms',
      },
      share: {
        homeTitle: 'Buy Shanghai YaoXue Snow World tickets interest-free — from ¥198',
        rulesTitle: 'Shanghai YaoXue Snow World Activity Terms',
      },
      product: {
        yuXue: 'YaoXue Ski Resort — Snow Play Ticket',
        huaXue: 'YaoXue Ski Resort — Ski Ticket',
      },
      home: {
        rulesBtn: 'Activity Terms',
        cardYuXue: 'Snow Play',
        cardSki: 'Skiing',
        priceFrom: 'from',
        ticketYuXueTypes: 'Standard / Concession Tickets',
        ticketSkiTypes: 'Beginner Slope 3-Hour Standard Ticket, etc.',
        disclaimer: 'Before placing an order, please review the access rights and validity period of your ticket to avoid mismatched benefits or expired tickets.',
        skiDesc0: 'Come to YaoXue for an exhilarating ice and snow adventure!',
        skiDesc1: 'Carve down the slopes and glide freely through the snow.',
        skiDesc2: 'Feel the speed and thrill — unlock endless skiing fun.',
        skiDescEn0: 'Come to YaoXue',
        skiDescEn1: 'for an exhilarating',
        skiDescEn2: 'ice and snow adventure!',
        skiDescEn3: 'Carve down the slopes',
        skiDescEn4: 'and glide freely',
        skiDescEn5: 'through the snow.',
        skiDescEn6: 'Feel the speed and thrill —',
        skiDescEn7: 'unlock endless skiing fun.',
        yuXueDesc0: 'Step into a world of ice and snow,',
        yuXueDesc1: 'ride the snow-country train through the aurora,',
        yuXueDesc2: 'play in the snow and race across the ice.',
        yuXueDesc3: 'Every corner brings joy,',
        yuXueDesc4: 'every moment holds a surprise.',
        yuXueDesc5: 'Come to YaoXue',
        yuXueDesc6: 'for a winter romance filled with happiness!',
        yuXueDescEn0: 'Step into a',
        yuXueDescEn1: 'world of ice and snow,',
        yuXueDescEn2: 'ride the snow-country train',
        yuXueDescEn3: 'through the aurora,',
        yuXueDescEn4: 'play in the snow',
        yuXueDescEn5: 'and race across the ice.',
        yuXueDescEn6: 'Every corner brings joy,',
        yuXueDescEn7: 'every moment holds a surprise.',
        yuXueDescEn8: 'Come to YaoXue',
        yuXueDescEn9: 'for a winter romance',
        yuXueDescEn10: 'filled with happiness!',
      },
      rules: {
        badge: 'Activity Terms',
        tabs: {
          yuXue: 'Snow Play',
          ski: 'Skiing',
        },
        footer: {
          slogan: 'YaoXue Ice & Snow World · Dream Journey, Passionate Snow Realm',
          hotlineLabel: 'Park Hotline: ',
        },
        rowLabels: {
          entry: 'Entry Time',
          validEntry: 'Valid Entry Time',
          ticketEntryExit: 'Ticket Entry & Exit Rules',
          purchaseRule: 'Purchase Rules',
          refund: 'Refund Policy',
          rentalRule: 'Rental Rules',
          audience: 'Eligible Guests',
          verify: 'Entry Verification',
        },
        notices: {
          default: 'Note: Detailed rules are subject to the latest park announcements.',
        },
        yuXue: {
          c0: {
            name: 'Advance Booking — 2026 Snow Play Standard Ticket (Offline) — All Guests',
            entry: 'Mar 5–Dec 31, 2026. After purchase, you will receive an SMS and a dedicated customer service agent will contact you to schedule your visit date. Please enter on your reserved date. Customer service: ',
            validEntry: 'Entry during operating hours',
            ticketEntryExit: 'Multiple entries to the snow play area on the same day',
            purchaseRule: 'Book at least one day in advance; minimum 1 ticket',
            refund: 'Refundable anytime after expiry',
            rentalRule: 'Snow play rentals: single rental per day',
            audience: 'All guests',
            verify: 'Facial recognition / ID card',
          },
          c1: {
            name: 'Buy & Use — 2026 Snow Play Concession Ticket (60+ or ages 3–11) — Offline',
            entry: 'Mar 5–Dec 31, 2026. After purchase, customer service will contact you to schedule your visit date',
            validEntry: 'Entry during operating hours',
            ticketEntryExit: 'Multiple entries to the snow play area on the same day',
            purchaseRule: 'Buy and use immediately',
            refund: 'Refundable anytime after expiry',
            rentalRule: 'Snow play rentals: single rental per day',
            audience: '1. Children: height &gt;1 m and ≤1.4 m, or age 3–11 (by ID) (must be accompanied by a paying adult);<br>2. Seniors: age 60 and above',
            verify: 'Facial recognition / ID card',
          },
        },
        huaXue: {
          c0: {
            name: 'Advance Booking — 2026 Beginner Slope 3-Hour Standard Ticket (Offline) — All Guests',
            entry: 'Off-peak Mar 5–Dec 31, 2026; peak May 1–Oct 7, 2026. After purchase, you will receive an SMS and a dedicated customer service agent will contact you to schedule your visit date. Please enter on your reserved date. Customer service: ',
            validEntry: 'Entry during operating hours',
            ticketEntryExit: 'Unlimited entries to the ski area on the same day',
            purchaseRule: 'Book at least one day in advance; minimum 1 ticket',
            refund: 'Refundable anytime after expiry',
            rentalRule: 'Snow play rentals: single rental per day',
            audience: 'All guests',
            verify: 'Facial recognition / ID card',
          },
          c1: {
            name: 'Advance Booking — 2026 Intermediate/Advanced Slope 4-Hour Standard Ticket (Offline) — All Guests',
            entry: 'Off-peak Mar 5–Dec 31, 2026; peak May 1–Oct 7, 2026. After purchase, you will receive an SMS and a dedicated customer service agent will contact you to schedule your visit date. Please enter on your reserved date. Customer service: ',
            validEntry: 'Entry during operating hours',
            ticketEntryExit: 'Unlimited entries to the ski area on the same day',
            purchaseRule: 'Book at least one day in advance; minimum 1 ticket',
            refund: 'Refundable anytime after expiry',
            rentalRule: 'Ski rentals: single rental per day',
            audience: 'All guests',
            verify: 'Facial recognition / ID card',
          },
          c2: {
            name: 'Advance Booking — 2026 Intermediate/Advanced Slope Unlimited Standard Ticket (Offline) — All Guests',
            entry: 'Off-peak Mar 5–Dec 31, 2026; peak May 1–Oct 7, 2026. After purchase, you will receive an SMS and a dedicated customer service agent will contact you to schedule your visit date. Please enter on your reserved date. Customer service: ',
            validEntry: 'Entry during operating hours',
            ticketEntryExit: 'Unlimited entries to the ski area on the same day',
            purchaseRule: 'Book at least one day in advance; minimum 1 ticket',
            refund: 'Refundable anytime after expiry',
            rentalRule: 'Ski rentals: single rental per day',
            audience: 'All guests',
            verify: 'Facial recognition / ID card',
          },
        },
      },
    },
  },
}
